import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class FilterUrlService {
  private url_filters = new BehaviorSubject<string>("");
  filters = this.url_filters.asObservable();
  filter = {
    sort:{ }
  };

  constructor(){ }
  
  /*recibe url con los nuevos filtros*/
  changeFilters(new_filter){
    this.url_filters.next(new_filter);
  }

  filterFirstLoad(settings:any){
    this.filter.sort = {};
    let url = '?sort=';
    //console.log("Settings: ", settings);
    //console.log("settings.columns: ", settings.columns);
    let columns:any = settings.columns;
    //console.log("Columns: ", columns);
    for(let key in columns){
      /*por cada campo en columnas*/
      //console.log("KEY in COlumns: ", key);
      if (columns.hasOwnProperty(key)) {
        if(columns[key].hasOwnProperty('sort')){
          this.filter['sort'][key] = columns[key]['sort'];
        }
      }
    }
    //console.log("In service");
    //console.log(this.filter);

    for(let key in this.filter['sort']){
        if(settings['columns'][key]['type'] == 'text' ){
            if(this.filter['sort'][key]=='asc'){
                url+='++'+key;
            }else{
                url+='--'+key;
            }
        }else{
            if(this.filter['sort'][key]=='asc'){
                url+='+'+key;
            }else{
                url+='-'+key;
            }
        }
        url+=',';
    }
    //console.log("URL FIRST: ", url);
    if(url.length > 6){
        this.url_filters.next(url.slice(0,-1));
    }else{
      this.url_filters.next('');
    }

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/filter-url.service.ts